import type { AuthSlice } from '../bs/auth'

/**
 * Croatian overrides for the signed-out screens.
 *
 * *zaposlenik* rather than *zaposleni*, *računalo* rather than *računar*,
 * *spremiti* rather than *sačuvati*, and *s pogona* where Bosnian writes *sa
 * pogona*. Everything else on these screens is word-for-word shared.
 */
export const auth: Partial<AuthSlice> = {
  'login.tagline': 'Kontrola i unapređenje — prijave i 5S s pogona.',
  'login.employeeCode': 'Šifra zaposlenika',
  'login.remember.hint': 'Isključite na zajedničkom računalu u pogonu.',
  'login.offlineNotice':
    'Radi i bez signala. Prijava se spremi na telefon i pošalje sama kad se veza vrati.',

  'login.twoFactor.recoveryCode.hint':
    'Jedan od kodova koje ste spremili pri uključivanju zaštite. Vrijedi samo jednom.',
}
